import validationRules from "../validationRules";
validationRules.register("int", function (record, fieldMetadataMap, fieldName, t) {
    var numeric = record[fieldName];
    if (!numeric) {
        return true;
    }
    var result = /^[0-9]+$/.test(numeric);
    if (result) {
        return true;
    }
    return "The value must be numeric characters";
});
